import React from 'react';
import './TrengerDuHjelp.css';
import { BodyLong, BodyShort, Heading } from '@navikt/ds-react';
import { Lenke } from '../../GeneriskeElementer/Lenke';
import { Chat2Icon, PaperplaneIcon, PhoneIcon } from '@navikt/aksel-icons';
import { openChatbot } from '@navikt/nav-dekoratoren-moduler';

const showFrida = (event: React.MouseEvent<HTMLAnchorElement>) => {
    openChatbot();
    event.preventDefault();
    event.stopPropagation();
};

export const TrengerDuHjelp = () => {
    return (
        <div className="kontaktfelt">
            <div className="kontaktfelt__content">
                <Heading size="large" level="2">
                    Trenger du hjelp?
                </Heading>

                <ul>
                    <li>
                        <BodyShort size="large">
                            <Lenke href="tel:55553336">
                                <PhoneIcon
                                    title="Telefonikon"
                                    style={{ height: '1.5rem', width: '1.5rem' }}
                                    aria-hidden="true"
                                />
                                Ring oss på 55 55 33 36
                            </Lenke>
                        </BodyShort>
                        <BodyLong spacing>
                            Åpent hverdager kl. 9–15. Vi kan ringe deg tilbake hvis ventetiden er
                            over 5 min.
                        </BodyLong>
                    </li>
                    <li>
                        <BodyShort size="large">
                            <Lenke href={'https://kontaktskjema.arbeidsgiver.nav.no/'}>
                                <PaperplaneIcon
                                    title="Sendikon"
                                    style={{ height: '1.5rem', width: '1.5rem' }}
                                    aria-hidden="true"
                                />
                                Kontaktskjema
                            </Lenke>
                        </BodyShort>
                        <BodyLong spacing>
                            Du kan skrive til oss hvis du ønsker hjelp til å rekruttere, inkludere
                            arbeidstakere og forebygge sykefravær.
                        </BodyLong>
                    </li>
                    <li>
                        <BodyShort size="large">
                            <Lenke href={'#'} onClick={showFrida}>
                                <Chat2Icon
                                    title="Dialogikon"
                                    style={{ height: '1.5rem', width: '1.5rem' }}
                                    aria-hidden="true"
                                />
                                Chat med Frida
                            </Lenke>
                        </BodyShort>
                        <BodyLong spacing>
                            Du møter først chatbot Frida som har døgnåpent. Mellom klokken 9 og
                            14.30 på hverdager kan du be Frida om å få chatte med en veileder.
                        </BodyLong>
                    </li>
                </ul>
            </div>
        </div>
    );
};
